"use client";

import { Back } from "../../ui/icons/back";

interface QuizHeaderProps {
  canGoBack: boolean;
  onBack: () => void;
}

export function QuizHeader({ canGoBack, onBack }: QuizHeaderProps) {
  return (
    <button
      onClick={onBack}
      className={`shrink-0 size-7 flex items-center justify-center cursor-pointer ${canGoBack ? "visible" : "invisible"}`}
    >
      <Back className="size-7 aspect-square" />
    </button>
  );
}
